/**
 * Formats latitude and longitude into a comma-separated coordinate string.
 *
 * @param {number} latitude - The latitude value.
 * @param {number} longitude - The longitude value.
 * @returns {string} The formatted coordinate string in `latitude,longitude` format with six decimal places.
 */
export const formatCoordinatesToString = (latitude, longitude) => {
    return latitude.toFixed(6) + ',' + longitude.toFixed(6);
};
/**
 * Checks if a given string is in valid coordinate format.
 *
 * @param {string} input - The coordinate string to validate.
 * @returns {boolean} `true` if the string matches the coordinate pattern, otherwise `false`.
 */
export const isCoordinates = (input) => {
    const sanitizedInput = input.replace(/\s+/g, '');
    const coordinatesPattern = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;
    return coordinatesPattern.test(sanitizedInput);
};
/**
 * Parses a coordinate string into numeric latitude and longitude values.
 *
 * @param {string} input - The coordinate string in `latitude,longitude` format.
 * @returns {{longitude: number, latitude: number}} An object containing numeric longitude and latitude values.
 */
export const parseCoordinates = (input) => {
    const [latitude, longitude] = input.split(',').map(Number);
    return { longitude, latitude };
};
